import { render, staticRenderFns } from "./multiselectable.vue?vue&type=template&id=01a012ed&scoped=true"
import script from "./multiselectable.vue?vue&type=script&lang=js"
export * from "./multiselectable.vue?vue&type=script&lang=js"
import style0 from "./multiselectable.vue?vue&type=style&index=0&id=01a012ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a012ed",
  null
  
)

export default component.exports